import tag from 'clean-tag';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { height } from 'styled-system';
import LessonEntryDataTable from './LessonEntryDataTable';
import TheoryApplicantsDataTable from './TheoryApplicantsDataTable';
import TheoryLessonsDataTable from './TheoryLessonsDataTable';
import DrivingApplicantsDataTable from './DrivingApplicantsDataTable';
import StatusDataTable from './StatusDataTable';
import UndoneDataTable from './UndoneDataTable';
import LessonsEditDataTable from './LessonsEditDatatable'
import SelectUndoneDataTable from "./SelectUndoneDataTable";
import LessonsReportDataTable from "./LessonsReportDataTable";
import DriverCardDataTable from "./DriverCardDataTable";

const DATATABLE_COMPONENTS = {
  'THEORY_LESSONS': TheoryLessonsDataTable,
  'THEORY_APPLICANTS': TheoryApplicantsDataTable,
  'DRIVING_APPLICANTS': DrivingApplicantsDataTable,
  'LESSON_ENTRIES': LessonEntryDataTable,
  'THEORY_STATUS': StatusDataTable,
  'DRIVING_STATUS': StatusDataTable,
  'UNDONE_STATUS': UndoneDataTable,
  'LESSONS_EDIT' : LessonsEditDataTable,
  'SELECT_UNDONE' : SelectUndoneDataTable,
  'LESSONS_REPORT' : LessonsReportDataTable,
  'DRIVER_CARD': DriverCardDataTable,
};

const PvDataTableWrapper = styled.div`
  overflow-x: auto;
  ${height};
  max-height: ${props => props.maxHeight};
  width: ${props => props.width};
  max-width: ${props => props.maxWidth};
`.withComponent(tag);

const PvTableHeader = styled.th`
  text-align: left;
  vertical-align: bottom;
  padding-left: ${props => props.theme.space[2]}px
  padding-right: ${props => props.theme.space[2]}px
  padding-top: ${props => props.theme.space[2]}px
  padding-bottom: ${props => props.theme.space[2]}px
  border-bottom: ${props => props.theme.borders[2]}
`;

const PvTableData = styled.td`
  position: relative;
  text-align: left;
  padding: ${props => props.theme.space[2]}px
`;

const PvTable = styled.table`
  width: 100%;
  border-spacing: 0;
`;
const PvTableRow = styled.tr`
  :nth-of-type(even) {
    background-color: ${props => props.theme.colors.grays[2]};
  }
`;

const DataTable = (props) => {
  if (!props.tableType) {
    return null;
  }

  const stylingRenderers = {
    table: PvTable,
    header: {
      //wrapper: 'div',
      //row: 'div',
      cell: PvTableHeader
    },
    body: {
      //wrapper: 'div',
      row: PvTableRow,
      cell: PvTableData
    }
  };

  const SpecificDataTable = DATATABLE_COMPONENTS[props.tableType];
  return (
    <PvDataTableWrapper height={props.tableHeight || '57vh'} maxHeight={props.tableMaxHeight || 'none'} width={props.tableWidth || '100%'} maxWidth={props.tableMaxWidth || 'none'} >
      <SpecificDataTable {...props} stylingRenderers={stylingRenderers} />
    </PvDataTableWrapper>
  );
};

DataTable.propTypes = {
  tableType: PropTypes.oneOf([
    'THEORY_LESSONS',
    'THEORY_APPLICANTS',
    'DRIVING_LESSONS',
    'DRIVING_APPLICANTS',
    'LESSON_ENTRIES',
    'THEORY_STATUS',
    'DRIVING_STATUS',
    'UNDONE_STATUS',
    'LESSONS_EDIT',
    'SELECT_UNDONE',
    'LESSONS_REPORT',
    'DRIVER_CARD',
  ]).isRequired,
  rows: PropTypes.array.isRequired,
  tableHeight: PropTypes.string
};

export default DataTable;


// WEBPACK FOOTER //
// ./src/components/datatable/index.js